import FormattedText from '@nespresso/catalog-components-react/containers/FormattedText';
import cn from 'classnames';
import styles from './Roast.module.scss';
import useTranslations from '@/widgets/hooks/useTranslations';
import type { Product } from '@/domain/Product';

export type RoastProps = {
  class?: string;
  product: Product;
};

export default function Roast({ class: className, product }: RoastProps) {
  const { t } = useTranslations();

  if (!product.roastingDescription) {
    return null;
  }

  const roastHeadingText = t('productList.quickView.roast.headingText');

  return (
    <section className={cn(styles.container, className)}>
      {roastHeadingText && <h2 class={styles.heading}>{roastHeadingText}</h2>}

      <FormattedText className={styles.description}>
        {product.roastingDescription}
      </FormattedText>
    </section>
  );
}
